const Historical = ({elements}) => elements.map((element, key) => <div key={key}>{element}</div>)

export default Historical